<script>
import { mapActions } from "vuex";

import moment from "@/utils/moment";
import professionalRegisterFlowMixin from "@/mixins/professionalRegisterFlowMixin";

export default {
  mixins: [professionalRegisterFlowMixin],

  props: {
    professional: {
      type: Object,
      required: true
    },
    events: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      preloader: false
    };
  },

  methods: {
    ...mapActions("management", ["createPGAOnGateway"]),

    formattedDate(datetime) {
      return moment(datetime).format("DD MMMM YYYY HH:mm:ss");
    },

    async createProfessionalPGAOnGateway() {
      this.preloader = true;

      try {
        const response = await this.createPGAOnGateway(
          this.professional.account.id
        );

        if (response.status === 200) {
          this.$toast.error(
            "Solicitação para criar conta no meio de pagamento enviado!"
          );
        } else {
          this.$toast.error(
            "Não foi possível enviar a solicitação para criar a conta do profissional no meio de pagamento!"
          );
        }
      } catch (e) {
        this.$toast.error(e);
      }
      this.preloader = false;
      this.$emit("refresh");
    }
  },
  computed: {
    isPGACreationFailed: function() {
      return this.professional.status === "payment_account_failed";
    }
  }
};
</script>

<template>
  <div class="body">
    <div class="status-details">
      <div class="description">
        Nessa etapa a carteira do profissional está sendo criada junto ao nosso
        meio de pagamento.
      </div>

      <div class="events">
        <ul>
          <li v-for="event in events">
            <b>{{ eventName(event.event_type) | getStatusName }}</b>

            <span>{{ formattedDate(event.created_at) }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="actions">
      <v-btn
        color="primary"
        small
        v-if="isPGACreationFailed"
        :loading="preloader"
        @click="createProfessionalPGAOnGateway"
      >
        Criar conta do profissional no meio de pagamento
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
.body {
  padding: 16px;
}

.status-details {
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: solid #424242 1px;
}

.description {
  width: 35%;
  text-align: justify;
}

.events {
  width: 60%;
  text-decoration: none;
}

li {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  padding: 4px 8px;
  list-style: none;
}

li:nth-child(even) {
  background: #eee;
}

.actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.action {
  display: flex;
  flex-direction: column;
}

span {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Register/Steps/PGA.vue